/**
 * @file Legend-list.tsx
 * @module LegendList
 * @description Apzīmējumu (leģendas) saraksta komponente Karšu pārlūkam.
 *              Attēlo grupētu sarakstu ar līniju un punktu stiliem — katram
 *              datu slānim parāda nosaukumu, piktogrammu un krāsu apzīmējumu.
 *              Stili nāk no Kartes vizualizācijas pārvaldības nosacījumiem.
 */
import { LineStyle, PointStyle } from "../../../store/Layers.repository";
import { LegendLineItem } from "./Legend-line-item";
import { LegendListItem } from "./Legend";

export default function LegendList({ items }: { items: LegendListItem[] }) {
	return (
		<ul className="pt-2 overflow-y-auto space-y-3 scroll-bar max-h-[95%]">
			{items.map((item, i) => {
				const legend = item.legend;
				console.log(item);

				return (
					<li key={i}>
						<p className="font-semibold leading-tight mb-1">{item.name}</p>
						<ul className="space-y-1 pl-4">
							{legend.lines.map((l: LineStyle, i: number) => (
								<LegendLineItem key={i} l={l}></LegendLineItem>
							))}
							{legend.points.map((p: PointStyle, i: number) => (
								<li key={i} className="flex gap-2 items-center">
									{p.piktogram ? (
										<img src={p.piktogram} alt="piktogram" className={"h-10 w-10 object-contain"} />
									) : item.name.includes("UVIS") ? (
										<div className="h-10 w-10 relative shrink-0 flex items-center justify-center">
											<div
												style={{
													background: p.color,
												}}
												className="h-2 w-2 rounded-full absolute"
											></div>
											<div
												style={{
													background: p.color,
													opacity: 0.5,
												}}
												className="h-10 w-10 rounded-full absolute"
											></div>
										</div>
									) : (
										<div
											className="h-10 w-10 rounded-full flex items-center justify-center"
											style={{
												background: p.color + "80",
											}}
										>
											<div
												style={{
													background: p.color,
												}}
												className="h-3 w-3 rounded-full shrink-0"
											></div>
										</div>
									)}
									<p className="ml-4">{p.name}</p>
								</li>
							))}
						</ul>
					</li>
				);
			})}
		</ul>
	);
}
